import OtherProps from "./components/others/OtherProps";
import PaySection from "./components/paysection/PaySection";
import Home from "./pages/home/Home";
import Room from "./pages/room/Room";
import {BrowserRouter, Routes, Route,} from 'react-router-dom'
import Contact from "./pages/contact/Contact";
import Blog from "./pages/blog/Blog";
import Post from "./pages/post/Post";

function App() {
  return (
    <BrowserRouter>
    <div className="App">
     <Routes>
      <Route exact path='/' element={ <Home/>}/>
      <Route  path='/others' element={ <OtherProps/>}/>
      <Route  path='/room/:id' element={ <Room/>}/>
      <Route  path='/pay' element={ <PaySection/>}/>
      <Route path='/contact' element={<Contact/>}/>
      <Route path='/blog' element={<Blog/>}/>
      <Route path='/singleblog/:id' element={<Post/>}/>
     </Routes>
    </div>
    </BrowserRouter>
  );
}

export default App;
